'use client';
import { useSideNavOpen } from '@/store';
import React, { useEffect, useState } from 'react';
import OpenCloseArrow from './OpenCloseArrow/OpenCloseArrow';

interface SectionTitleProps {
	title: string;
	toggleOpen: () => void;
	open: boolean;
}

const SectionTitle = ({ title, toggleOpen, open }: SectionTitleProps) => {
	const sideNavOpen = useSideNavOpen();
	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!sideNavOpen && isMounted) return null;
	return (
		<button
			onClick={toggleOpen}
			className="flex gap-2 justify-between items-center
			text-sm font-bold p-2.5 
			group hover:text-electric-sky transition-colors duration-200 ease-in-out"
		>
			{title}
			<OpenCloseArrow open={open} />
		</button>
	);
};

export default SectionTitle;
